<template>
  <div>
    <div class="estore-body">
      <div class="estore-content inventory-content customers-wrapper">
        <b-row>
          <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <div class="filter-wrapper">
              <b-form-select v-model="selectedStatusSearchOption" :options="statusSearchOptions"
                @input="advanceSearch" />
            </div>
          </b-col>
          <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
            <div class="filter-wrapper">
              <b-input-group prepend>
                <b-form-input placeholder="Search" @keyup.native="debounceSearch" v-model="keyword"></b-form-input>
                <b-dropdown text="Advanced" variant="primary" slot="append">
                  <b-dropdown-item v-for="field in searchableFields" :key="field.value"
                    @click="beforeSearch(field.value)">
                    {{ field.text }}
                    <i v-if="selectedSearchableFieldOption === field.value" class="ml-1">
                      <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1" />
                    </i>
                  </b-dropdown-item>
                  <template v-if="paymentTypeOptions && paymentTypeOptions.length > 0">
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-button v-b-toggle.paymentType variant="dropdown-like" class="shadow-none">Mode of
                      Payment</b-button>
                  </template>
                  <b-collapse id="paymentType" class="mt-2">
                    <b-dropdown-item v-for="options in paymentTypeOptions" :key="options.value"
                      @click="beforeSearch(options.value, options.text)">{{ options.text }}
                      <i v-if="payment_type === options.value" class="ml-1">
                        <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1" />
                      </i>
                    </b-dropdown-item>
                  </b-collapse>
                  <template v-if="logisticsTypeOptions && logisticsTypeOptions.length > 0
                  ">
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-button v-b-toggle.logisticsType variant="dropdown-like" class="shadow-none">Logistic
                      Type</b-button>
                  </template>
                  <b-collapse id="logisticsType" class="mt-2">
                    <b-dropdown-item v-for="options in logisticsTypeOptions" :key="options.value"
                      @click="beforeSearch(options.value, options.text)">{{ options.text }}
                      <i v-if="delivery_type === options.text" class="ml-1">
                        <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1" />
                      </i>
                    </b-dropdown-item>
                  </b-collapse>
                </b-dropdown>
              </b-input-group>
            </div>
          </b-col>
          <b-col sm="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0"> </b-col>
          <b-col md="4" class="text-left text-md-right">
            <b-button variant="primary btn-table-export" @click="showExportModal">
              Export
            </b-button>
          </b-col>
        </b-row>
        <div>
          <div class="data-container">
            <b-table :items="items" :fields="tableFields" responsive show-empty :empty-text="emptyText">
              <template slot="order_transaction" slot-scope="data">
                {{ data.value.transaction_no }}
              </template>
              <template slot="ordered_via" slot-scope="data">
                <template v-if="data.item.order_transaction.ordered_via == 'web'">Website</template>
                <template v-else-if="data.item.order_transaction.ordered_via == 'rush+'">RUSH+</template>
                <template v-else-if="data.item.order_transaction.ordered_via == 'mobile'
                ">Mobile</template>
                <template v-else-if="data.item.order_transaction.ordered_via == 'globeone'
                ">NG1</template>
                <template v-else> - </template>
              </template>
              <template slot="date_ordered" slot-scope="data">
                {{ formatDate(data.value) }}
              </template>
              <template slot="brand_name" slot-scope="data">
                {{ data.value }} ({{ data.item.branch }})
              </template>
              <template slot="payment_type_description" slot-scope="data">
                {{ data.value }}
              </template>
              <template slot="order_amount" slot-scope="data">
                Php {{ formatAmount(data.item.order_amount) }}
              </template>
              <template slot="points_earned" slot-scope="data">
                <template v-if="data.value == null"> - </template>
                <template v-else>
                  {{ formatPointsValue(data.item.points_earned) }}
                </template>
              </template>
              <template slot="voucher_code" slot-scope="data">
                <template v-if="data.value == null || data.value == ''">
                  N/A
                </template>
                <template v-else>
                  {{ data.value }}
                </template>
              </template>
              <template slot="special_discount" slot-scope="data">
                <span class="text-capitalize">{{ data.value }}</span>
              </template>
              <template slot="address" slot-scope="data">
                <div>
                  <span v-if="data.item.payment_type !== 'CP'">{{
                    data.item.delivery_address
                    }}</span>
                  <span v-else>N/A</span>
                </div>
              </template>
              <template slot="schedule" slot-scope="data">
                <span v-if="data.item.payment_type === 'CP'">
                  For Pickup -
                  <strong>{{ data.item.pickup_schedule }}</strong>
                </span>
                <span v-else>
                  For Delivery -
                  <strong>{{ data.item.delivery_schedule }}</strong>
                </span>
              </template>
              <template slot="status" slot-scope="data">
                <span :class="data.value + '-container table-status-container'">{{ showFormattedStatus(data.value)
                  }}</span>
              </template>
              <template slot="product_details" slot-scope="data">
                <div v-if="data.item.order_items.length !== 0">
                  <div class="mt-1" style="border: 1px solid #ccc; padding: 5px"
                    v-for="product in data.item.order_items" :key="product.uuid">
                    <span>Product Name :
                      <strong>{{ product.product_name }} </strong></span>
                    <br />
                    <template v-if="product.variation_code !== null &&
                      product.variation_desc.length > 0
                    ">
                      <span>Variation Description : </span>
                      <div v-for="(productVariation, index) in JSON.parse(
                        product.variation_desc
                      )" v-bind:key="index">
                        <span>{{ productVariation.attribute | capitalize }} :
                          {{ productVariation.value | capitalize }}</span>
                        <br />
                      </div>
                    </template>
                    <span>Category : {{ product.category_name }}</span>
                    <br />
                    <span>SKU : {{ product.sku }}</span>
                    <br />
                    <span>Quantity : {{ parseInt(product.quantity) }}</span>
                    <br />
                    <span>Price : Php {{ formatAmount(product.item_amount) }}</span>
                    <br />
                  </div>
                </div>
                <div v-else>No Product Items</div>
              </template>
              <template slot="action" slot-scope="data">
                <template v-if="!loading">
                  <i class="action-button ml-1" style="position: relative; top: -2px">
                    <img @click="
                      viewOrder({
                        uuid: data.item.uuid,
                        transaction_uuid: data.item.order_transaction.uuid,
                      })
                      " src="@/assets/images/actions/view.svg" alt="View" />
                  </i>
                </template>
                <template v-else>
                  <div class="loader d-inline-block"></div>
                </template>
              </template>
            </b-table>
          </div>
        </div>
        <div class="mt-3">
          <b-row no-gutters>
            <b-col>
              <div class="mt-1">
                <span class="pagination-indicator">{{ pagination.currentFirstItem }}-{{ pagination.currentLastItem }} of {{ pagination.maxPage }} page</span>
                  
                <b-pagination hide-goto-end-buttons align="left" size="md" class="custom-pagination-arrow-only" :total-rows="pagination.totalPerPage > 0
                  ? pagination.maxPage * pagination.totalPerPage
                  : 1
                  " :limit="pagination.totalPerPage > 0 ? 3 : 1" :per-page="pagination.totalPerPage"
                  v-model="pagination.currentPage" @change="getOrders">
                </b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <ViewOrder :status="modal.view_order.status" :orderUuid="order_uuid" />
      <ViewDepositSlipImage :status="modal.view_deposit_slip_image.status" :depositSlipImage="depositSlipImage" />
    </div>
    <ExportModal :parameters="exportParameters" />
    <ProofOfDeliveryModalVue />
  </div>
</template>

<script>
import ViewOrder from "@/components/orders/ViewOrder";
import ViewDepositSlipImage from "@/components/orders/ViewDepositSlipImage";
import Datepicker from "vue-bulma-datepicker";
import { mapState, mapGetters } from "vuex";
import ExportModal from "@/components/orders/ExportModal";
import _ from "lodash";
import ProofOfDeliveryModalVue from "@/components/orders/ProofOfDeliveryModal.vue";

export default {
  data() {
    return {
      viewHovered: false,
      fields: [
        {
          key: "order_transaction",
          label: "Transaction No.",
        },
        {
          key: "order_no",
          label: "Order ID",
          sortable: true,
        },
        {
          key: "customer_name",
          label: "Customer Name",
          sortable: true,
        },
        {
          key: "ordered_via",
          label: "Customer Channel",
          sortable: true,
        },
        {
          key: "date_ordered",
          sortable: true,
        },
        {
          key: "brand_name",
          label: "Brand (Branch)",
          sortable: true,
        },
        {
          key: "order_amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "voucher_code",
          sortable: true,
          label: "Promo Code",
        },
        {
          key: "special_discount_types",
          sortable: true,
          label: "Special Discount",
          formatter: (value, key, { special_discount_approved }) => {
            const discountTypeLables = {
              pwd: "PWD",
              senior: "Senior Citizen"
            }
            if ((special_discount_approved/1) && value) {
              return discountTypeLables[value.toLowerCase()];
            }
            return "N/A";
          }
        },
        {
          key: "payment_type_description",
          sortable: true,
          label: "Mode of Payment",
          formatter: (value, key, item) => {
            return item.payment_type === "VOUCHER"
              ? "Voucher"
              : item.payment_type_description;
          },
        },
        {
          key: "delivery_type",
          sortable: true,
        },
        {
          key: "delivery_fee",
          sortable: false,
          formatter: (value, key, item) => {
            const delivery_fee = item.fees
              .map((fee) => fee)
              .find((fee) => fee.name === "Delivery Fee");
            return delivery_fee
              ? `${delivery_fee.value_type.charAt(0)}${delivery_fee.value_type
                .substring(1)
                .toLowerCase()} ${delivery_fee.value}`
              : "N/A";
          },
        },
        {
          key: "grab_delivery_id",
          label: "Delivery ID",
          formatter: (_, __, item) => {
            return item.grab_delivery && item.grab_delivery.status !== "interim"
              ? item.grab_delivery.delivery_id
              : "N/A";
          },
        },
        {
          key: "redeemed_points",
          label: "Points Redeemed",
          sortable: true,
          formatter: (value, _, __) => {
            return this.formatPointsValue(value);
          }
        },
        {
          key: "points_earned",
          sortable: true
        },
        {
          key: "refund_request_date",
          label: "Date and Time of Refund Request",
          sortable: true,
          formatter: (_, __, item) => {
            const is_paymongo_refund = !!item.paymongo_payment_refund;
            const is_xendit_refund = !!item.xendit_refund;
            const is_gcash_mp_refund = !!item.gcash_mp_refund;

            const formatDate = (value) => {
              return this.$moment(value).format("YYYY-MM-DD HH:mm:ss");
            };

            if (
              is_paymongo_refund &&
              item.paymongo_payment_refund.datetime_requested
            )
              return formatDate(
                item.paymongo_payment_refund.datetime_requested
              );
            else if (is_xendit_refund && item.xendit_refund.datetime_requested)
              return formatDate(item.xendit_refund.datetime_requested);
            else if (
              is_gcash_mp_refund &&
              item.gcash_mp_refund.datetime_requested
            )
              return formatDate(item.gcash_mp_refund.datetime_requested);
            else return "N/A";
          },
        },
        {
          key: "refund_request",
          label: "Requested the Refund",
          sortable: true,
          tdClass: "text-capitalize",
          formatter: (_, __, item) => {
            const is_paymongo_refund = !!item.paymongo_payment_refund;
            const is_xendit_refund = !!item.xendit_refund;
            const is_gcash_mp_refund = !!item.gcash_mp_refund;

            if (is_paymongo_refund && item.paymongo_payment_refund.requested_by)
              return item.paymongo_payment_refund.requested_by;
            else if (is_xendit_refund && item.xendit_refund.requested_by)
              return item.xendit_refund.requested_by;
            else if (is_gcash_mp_refund && item.gcash_mp_refund.requested_by)
              return item.gcash_mp_refund.requested_by;
            else return "N/A";
          },
        },
        {
          key: "refund_sent_date",
          label: "Date and Time Refund Sent",
          sortable: true,
          tdClass: "text-capitalize",
          formatter: (_, __, item) => {
            const is_paymongo_refund = !!item.paymongo_payment_refund;
            const is_xendit_refund = !!item.xendit_refund;
            const is_gcash_mp_refund = !!item.gcash_mp_refund;

            const formatDate = (value) => {
              return this.$moment(value).format("YYYY-MM-DD HH:mm:ss");
            };

            if (
              is_paymongo_refund &&
              item.paymongo_payment_refund.datetime_refund_sent
            )
              return formatDate(
                item.paymongo_payment_refund.datetime_refund_sent
              );
            else if (
              is_xendit_refund &&
              item.xendit_refund.datetime_refund_sent
            )
              return formatDate(item.xendit_refund.datetime_refund_sent);
            else if (
              is_gcash_mp_refund &&
              item.gcash_mp_refund.datetime_refund_sent
            )
              return formatDate(item.gcash_mp_refund.datetime_refund_sent);
            else return "N/A";
          },
        },
        {
          key: "reason_for_cancellation",
          label: "Remarks",
          sortable: false,
          formatter: (value) => {
            if (value) return value;
            return "N/A";
          },
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      generikaFields: [
        {
          key: "order_transaction",
          label: "Transaction No.",
        },
        {
          key: "order_no",
          label: "Order ID",
          sortable: true,
        },
        {
          key: "customer_name",
          label: "Customer Name",
          sortable: true,
        },
        {
          key: "ordered_via",
          label: "Customer Channel",
          sortable: true,
        },
        {
          key: "date_ordered",
          sortable: true,
        },
        {
          key: "medPadalaCode",
          label: "MEDPadala Code",
          sortable: true,
        },
        {
          key: "medPadalaAmount",
          label: "MEDPadala Amount used",
          sortable: true,
        },
        {
          key: "brand_name",
          label: "Brand (Branch)",
          sortable: true,
        },
        {
          key: "order_amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "voucher_code",
          sortable: true,
          label: "Promo Code",
        },
        {
          key: "payment_type_description",
          sortable: true,
          label: "Mode of Payment",
        },
        {
          key: "delivery_type",
          sortable: true,
        },
        {
          key: "delivery_fee",
          sortable: false,
          formatter: (value, key, item) => {
            const delivery_fee = item.fees
              .map((fee) => fee)
              .find((fee) => fee.name === "Delivery Fee");
            return delivery_fee
              ? `${delivery_fee.value_type.charAt(0)}${delivery_fee.value_type
                .substring(1)
                .toLowerCase()} ${delivery_fee.value}`
              : "N/A";
          },
        },
        {
          key: "grab_delivery_id",
          label: "Grab Delivery ID",
          formatter: (_, __, item) => {
            return item.grab_delivery && item.grab_delivery.status !== "interim"
              ? item.grab_delivery.delivery_id
              : "N/A";
          },
        },
        {
          key: "redeemed_points",
          label: "Points Redeemed",
          sortable: true,
          formatter: (value, _, __) => {
            return this.formatPointsValue(value);
          }
        },
        {
          key: "points_earned",
          sortable: true
        },
        {
          key: "refund_request_date",
          label: "Date and Time of Refund Request",
          sortable: true,
          formatter: (_, __, item) => {
            const is_paymongo_refund = !!item.paymongo_payment_refund;
            const is_xendit_refund = !!item.xendit_refund;
            const is_gcash_mp_refund = !!item.gcash_mp_refund;

            const formatDate = (value) => {
              return this.$moment(value).format("YYYY-MM-DD HH:mm:ss");
            };

            if (
              is_paymongo_refund &&
              item.paymongo_payment_refund.datetime_requested
            )
              return formatDate(
                item.paymongo_payment_refund.datetime_requested
              );
            else if (is_xendit_refund && item.xendit_refund.datetime_requested)
              return formatDate(item.xendit_refund.datetime_requested);
            else if (
              is_gcash_mp_refund &&
              item.gcash_mp_refund.datetime_requested
            )
              return formatDate(item.gcash_mp_refund.datetime_requested);
            else return "N/A";
          },
        },
        {
          key: "refund_request",
          label: "Requested the Refund",
          sortable: true,
          tdClass: "text-capitalize",
          formatter: (_, __, item) => {
            const is_paymongo_refund = !!item.paymongo_payment_refund;
            const is_xendit_refund = !!item.xendit_refund;
            const is_gcash_mp_refund = !!item.gcash_mp_refund;

            if (is_paymongo_refund && item.paymongo_payment_refund.requested_by)
              return item.paymongo_payment_refund.requested_by;
            else if (is_xendit_refund && item.xendit_refund.requested_by)
              return item.xendit_refund.requested_by;
            else if (is_gcash_mp_refund && item.gcash_mp_refund.requested_by)
              return item.gcash_mp_refund.requested_by;
            else return "N/A";
          },
        },
        {
          key: "refund_sent_date",
          label: "Date and Time Refund Sent",
          sortable: true,
          tdClass: "text-capitalize",
          formatter: (_, __, item) => {
            const is_paymongo_refund = !!item.paymongo_payment_refund;
            const is_xendit_refund = !!item.xendit_refund;
            const is_gcash_mp_refund = !!item.gcash_mp_refund;

            const formatDate = (value) => {
              return this.$moment(value).format("YYYY-MM-DD HH:mm:ss");
            };

            if (
              is_paymongo_refund &&
              item.paymongo_payment_refund.datetime_refund_sent
            )
              return formatDate(
                item.paymongo_payment_refund.datetime_refund_sent
              );
            else if (
              is_xendit_refund &&
              item.xendit_refund.datetime_refund_sent
            )
              return formatDate(item.xendit_refund.datetime_refund_sent);
            else if (
              is_gcash_mp_refund &&
              item.gcash_mp_refund.datetime_refund_sent
            )
              return formatDate(item.gcash_mp_refund.datetime_refund_sent);
            else return "N/A";
          },
        },
        {
          key: "reason_for_cancellation",
          label: "Remarks",
          sortable: false,
          formatter: (value) => {
            if (value) return value;
            return "N/A";
          },
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      keyword: null,
      emptyText: "No Records Found.",
      items: [],
      selectedDateOption: [],
      range: null,
      payment_type: null,
      delivery_type: null,
      keyAccountsUuid: {
        local: [
          // "8e9bc0ba-aa25-4c75-96d5-b16703916b35", // estore
          "5f34dbaf-93e0-46bd-9779-777b7cfccc30", // generika
        ],
        Development: [
          "5f34dbaf-93e0-46bd-9779-777b7cfccc30", // generika
        ],
        Canary: [
          // "8e9bc0ba-aa25-4c75-96d5-b16703916b35", // estore
          "5f34dbaf-93e0-46bd-9779-777b7cfccc30", // generika
        ],
        Staging: [
          "90dd82f7-0e39-430c-9647-cdf7e3741708", // generika
        ],
        Release: [
          // "d52635e6-5363-4f7b-9119-d5c64fad8a09", // estore
          "e07df259-aae6-4ea8-b507-b07f08131727", // generika
        ],
        Production: [
          // "d52635e6-5363-4f7b-9119-d5c64fad8a09", // estore
          "e07df259-aae6-4ea8-b507-b07f08131727", // generika
        ],
      },
      order_uuid: null,
      exportParameters: null,
    };
  },
  components: {
    ViewOrder,
    ViewDepositSlipImage,
    Datepicker,
    ExportModal,
    ProofOfDeliveryModalVue,
  },
  computed: {
    ...mapState("estoreOrders", [
      "orders",
      "currentPage",
      "maxPage",
      "nextPage",
      "prevPage",
      "searchableFields",
      "statusSearchOptions",
      "defaultStatusSearchOption",
      "defaultSearchableFieldOption",
      "searchKeyword",
      "errors",
      "loading",
      "pagination",
      "modal",
      "depositSlipImage",
      "paymentTypeOptions",
      "logisticsTypeOptions",
    ]),
    ...mapState("estoreSettings", ["settings"]),
    ...mapState("customers", ["merchantUuid"]),
    ...mapGetters("auth", ["userMetas"]),
    selectedStatusSearchOption: {
      get: function () {
        return this.defaultStatusSearchOption;
      },
      set: function (value) {
        this.$store.commit("estoreOrders/defaultStatusSearchOption", value);
      },
    },
    selectedSearchableFieldOption: {
      get: function () {
        return this.defaultSearchableFieldOption;
      },
      set: function (value) {
        this.$store.commit("estoreOrders/defaultSearchableFieldOption", value);
      },
    },
    tableFields() {
      return this.keyAccountsUuid[process.env.VUE_APP_MODE].includes(
        this.merchantUuid
      )
        ? this.generikaFields
        : this.fields;
    },
  },
  created() {
    this.debounceSearch = _.debounce(() => {
      this.advanceSearch();
    }, 500);
    this.getOrders(1);
    this.getStatusOption();
    this.getSearchableFieldsOption();
    this.getSettings();
  },
  methods: {
    selectedDate(value) {
      let range = {};

      if (value.length == 2) {
        range = this.getRange(value);

        this.filterDate(range, this.currentPage);
      }
    },
    getRange(value) {
      this.range = value;

      let range = {
        start: this.$moment(value[0]).format("YYYY-MM-DD"),
        end: this.$moment(value[1]).format("YYYY-MM-DD"),
      };

      return range;
    },
    filterDate(range, page = 1) {
      if (this.searchString.trim() !== "") {
        let param = this.getSearchParams(true, page);

        this.$store.dispatch("transactions/search", param);
      } else {
        let param = {
          apiFields: range,
          page: page,
        };

        this.$store.dispatch("transactions/filterByDateFull", param);
      }
    },
    formatDate: function (date) {
      return this.$moment(date).format("LLL");
    },
    showFormattedStatus(status) {
      if (status == "in_process") {
        return "In Process";
      } else {
        return status;
      }
    },
    getOrders(page) {
      this.emptyText = "Loading...";
      this.items = [];
      let param = {
        page: page,
        payload: {
          filters: {
            paired_key: this.selectedStatusSearchOption,
            keyword: this.keyword,
            column: this.selectedSearchableFieldOption,
          },
          payment_type: this.payment_type,
          delivery_type: this.delivery_type,
          branch_uuid: this.userMetas.branches,
        },
      };
      let _this = this;
      this.$store.dispatch("estoreOrders/getOrders", param).then(function () {
        _this.orders.map((order) => {
          let medPadala = null;
          if (order.order_transaction != null) {
            medPadala = order.order_transaction.customizations.find(
              (customization) => customization.type === "med-padala"
            );
          }

          if (medPadala) {
            const { values } = medPadala;
            order.medPadalaCode = values.mpCode;
            order.medPadalaAmount = Number(values.amount).toFixed(2);
          }
        });

        _this.items = _this.orders;
        _this.emptyText = "No Records Found.";
      });
    },
    showExportModal() {
      this.exportParameters = {
        filters: {
          paired_key: this.selectedStatusSearchOption,
          keyword: this.keyword,
          column: this.selectedSearchableFieldOption,
        },
        branch_uuid: [],
        payment_type: this.payment_type,
        delivery_type: this.delivery_type,
      };
      this.$root.$emit("bv::show::modal", "export-estore-orders-modal");
    },
    formatAmount(amount) {
      let formatted = parseFloat(amount).toLocaleString(undefined, {
        maximumFractionDigits: 2,
      });
      if (formatted.indexOf(".") === -1) {
        return formatted + ".00";
      }
      return formatted;
    },
    statusColorCode(status) {
      if (status === "in_process") {
        return "outline-info";
      } else if (status === "dispatched" || status === "for_pickup") {
        return "outline-warning";
      } else if (status === "delivered") {
        return "outline-success";
      } else if (status === "cancelled") {
        return "outline-danger";
      } else {
        return "outline-secondary";
      }
    },
    getStatusOption() {
      this.$store.dispatch("estoreOrders/getStatusOption");
    },
    getSearchableFieldsOption() {
      this.$store.dispatch("estoreOrders/getSearchableFieldsOption");
    },
    advanceSearch() {
      this.getOrders(1);
    },
    beforeSearch(value, text = null) {
      if (this.paymentTypeOptions.find((payment) => payment.value == value)) {
        this.selectedSearchableFieldOption = "orders.payment_type";
        this.payment_type = value;
        this.delivery_type = null;
      } else if (
        this.logisticsTypeOptions.find((logistics) => logistics.value == value)
      ) {
        this.selectedSearchableFieldOption = "orders.delivery_type";
        this.delivery_type = text;
        this.payment_type = null;
      } else {
        this.selectedSearchableFieldOption = value;
        this.payment_type = null;
        this.delivery_type = null;
      }
      this.advanceSearch();
    },
    updateStatus(data, status) {
      let param = {
        uuid: data.item.uuid,
        payload: {
          status: status,
          mobile_number: data.item.mobile_number,
          fullname: data.item.customer_name,
        },
      };
      let _this = this;
      this.$store
        .dispatch("estoreOrders/updateStatus", param)
        .then(function () {
          _this.getOrders(_this.pagination.currentPage);
        });
    },
    showModal(modal) {
      this.$root.$emit("bv::show::modal", modal);
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    handleCancel(modal, data) {
      let _this = this;
      let param = {
        uuid: data.item.uuid,
        payload: {
          status: status,
          mobile_number: data.item.mobile_number,
          fullname: data.item.customer_name,
        },
      };
      this.$store.dispatch("estoreOrders/cancelOrder", param).then(function () {
        _this.getOrders(_this.currentPage);
        _this.hideModal(modal);
      });
    },
    async getSettings() {
      this.$store.dispatch("estoreSettings/viewSettings");
    },
    async viewOrder({ uuid, transaction_uuid}) {
      this.order_uuid = uuid;
      await this.$store.dispatch("estoreOrders/getOrderTransactionDetails", {
        uuid: transaction_uuid,
      });

      if (!this.errors) {
        this.$store.commit("estoreOrders/setModal", {
          type: "view_order",
          status: true,
        });
      }
    },
    formatPointsValue(value) {
      if (value)
        return Number(parseFloat(value)).toLocaleString("en");

      return value;
    }
  },
  filters: {
    capitalize: function (str) {
      const splitStr = str.toLowerCase().split("_");

      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }

      return splitStr.join(" - ");
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hidden", (bvEvent) => {
      this.$store.commit("estoreOrders/setModal", {
        type: "view_order",
        status: false,
      });
      if (bvEvent.target.id == "deposit-slip-image") {
        this.$store.commit("estoreOrders/setModal", {
          type: "view_order",
          status: true,
        });
        this.$store.commit("estoreOrders/setModal", {
          type: "view_deposit_slip_image",
          status: false,
        });
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.btn-dropdown-like {
  background: white;
}

.loader {
  position: relative;
  top: 2px;
  left: 2px;
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #ff8828;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
